import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { FormGroup, Input, Label } from 'reactstrap';
import { STATIC_PATH } from '../../config';
import { FMessage } from '../../hoc/IntlComponents';
import CustomControl from '../CustomControl/CustomControl';
import Hint from '../Hint/Hint';

const TIK_TOK_GROUP_PATH = 'main_settings_block/4';

const FlowTikTokControls = ({
  isStreamTikTok,
  settings,
  handleCurrentLandingSettingsChange,
  handleIsTikTokChange,
}) => {
  const [selectValue, setSelectValue] = useState(null);

  useEffect(() => {
    if (isStreamTikTok) {
      handleCurrentLandingSettingsChange((draft) => ({
        ...draft,
        [`${TIK_TOK_GROUP_PATH}/27`]: true, // rekv_text
        [`${TIK_TOK_GROUP_PATH}/35`]: true, // your_contacts
      }));
    }
  }, [isStreamTikTok]);

  useEffect(() => {
    let foundKey = Object.keys(settings)
      .find((k) => k.includes(`${TIK_TOK_GROUP_PATH}/35/31`))
      ?.split('/');

    let foundValue = foundKey && foundKey[foundKey.length - 1];
    foundValue && setSelectValue(foundValue);
  }, [settings]);

  const handleSelectChange = (value) => {
    setSelectValue(value.value);

    handleCurrentLandingSettingsChange((draft) => {
      for (let key in draft) {
        if (key.includes(`${TIK_TOK_GROUP_PATH}/35/31`)) {
          delete draft[key];
        }
      }

      return draft;
    });
  };

  const handleContactInputChange = ({ target: { name, value } }) => {
    handleCurrentLandingSettingsChange((draft) => ({
      ...draft,
      // 2 - email, 3 - phone, 4 - skype
      [name === '2' ? `${TIK_TOK_GROUP_PATH}/35/2` : `${TIK_TOK_GROUP_PATH}/35/31/${name}`]: value,
    }));
  };

  return (
    <>
      <CustomControl
        id="tiktok-stream"
        value="tiktok-stream"
        checked={isStreamTikTok}
        onChange={handleIsTikTokChange}
        type="checkbox"
        className="custom-control-xs mt-3"
        label={<FMessage id="flow.form.tiktok.label" />}
      />

      {isStreamTikTok ? (
        <>
          <div className="flow-tiktok-controls-rekv">
            <CustomControl
              id="rekv-text"
              value="rekv-text"
              type="checkbox"
              className="custom-control-xs mr-0"
              label={<FMessage id="flow.features.rekv_text.label" />}
              inline
              checked
              disabled
            />
            <Hint
              title={<FMessage id="flow.features.rekv_text.label" />}
              id="rekv-text-hint"
              placement="bottom"
              popoverClassName="feature-hint-popover"
            >
              <FMessage id="flow.features.rekv_text.desc" />
              <img
                src={`${STATIC_PATH}/img/flow-feature-previews/27.png`}
                className="feature-hint-preview-img"
              />
            </Hint>
          </div>

          <div className="mt-2 mb-3">
            <CustomControl
              id="contacts-data"
              value="contacts-data"
              type="checkbox"
              className="custom-control-xs mr-0"
              label={<FMessage id="flow.features.your_contacts.label" />}
              inline
              checked
              disabled
            />
            <Hint
              title={<FMessage id="flow.features.your_contacts.label" />}
              id="your-contacts-hint"
              placement="bottom"
              popoverClassName="feature-hint-popover"
            >
              <FMessage id="flow.features.your_contacts.desc" />
              <img
                src={`${STATIC_PATH}/img/flow-feature-previews/35.png`}
                className="feature-hint-preview-img"
              />
            </Hint>
          </div>

          <FormGroup>
            <Label for="email">
              <FMessage id="flow.features.your_contacts.email.label" />
            </Label>
            <Input
              name="2"
              type="text"
              bsSize="sm"
              onChange={handleContactInputChange}
              value={(settings && settings[`${TIK_TOK_GROUP_PATH}/35/2`]) || ''}
            />
            <Select
              className="Select--sm my-3"
              clearable={false}
              searchable={false}
              options={[
                { label: <FMessage id="flow.features.your_contacts.phone.label" />, value: '3' },
                { label: <FMessage id="flow.features.your_contacts.skype.label" />, value: '4' },
              ]}
              value={selectValue}
              onChange={handleSelectChange}
              placeholder={<FMessage id="flow.features.your_contacts.select.placeholder" />}
            />
            {selectValue === '3' ? (
              <Input
                name="3"
                type="text"
                bsSize="sm"
                onChange={handleContactInputChange}
                value={(settings && settings[`${TIK_TOK_GROUP_PATH}/35/31/3`]) || ''}
              />
            ) : null}
            {selectValue === '4' ? (
              <Input
                name="4"
                type="text"
                bsSize="sm"
                onChange={handleContactInputChange}
                value={(settings && settings[`${TIK_TOK_GROUP_PATH}/35/31/4`]) || ''}
              />
            ) : null}
          </FormGroup>
        </>
      ) : null}
    </>
  );
};

export default FlowTikTokControls;
